import { encryptStorage } from 'src/Util'
import { usersAPI } from '../api'
//import { usersAPI } from '../api'

//Action Types
//export const LIST_USER = 'LIST_USER'
export const LIST_USER_SUCCESS = 'LIST_USER_SUCCESS'
export const LIST_USER_FAILURE = 'LIST_USER_FAILURE'

export const COMPANY_LIST_SUCCESS = 'COMPANY_LIST_SUCCESS'
export const COMPANY_LIST_FAILURE = 'COMPANY_LIST_FAILURE'

export const USER_ROLES_SUCCESS = 'USER_ROLES_SUCCESS'
export const USER_ROLES_FAILURE = 'USER_ROLES_FAILURE'

export const GET_REGION_SUCCESS = 'GET_REGION_SUCCESS'
export const GET_REGION_FAILURE = 'GET_REGION_FAILURE'

export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const CREATE_USER_FAILURE = 'CREATE_USER_SUCCESS'

export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS'
export const EDIT_USER_FAILURE = 'EDIT_USER_FAILURE'

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const TOGGLE_USER_SUCCESS = 'TOGGLE_USER_SUCCESS'
export const TOGGLE_USER_FAILURE = 'TOGGLE_USER_FAILURE'

export const SEND_FAQ_QUERY_SUCCESS = 'SEND_FAQ_QUERY_SUCCESS'
export const SEND_FAQ_QUERY_ERROR = 'SEND_FAQ_QUERY_ERROR'

export const ACTIVATE_DEACTIVATE_COMPANY = 'ACTIVATE_DEACTIVATE_COMPANY'
export const CLEAR_ACTIVATE_DEACTIVATE_RES = 'CLEAR_ACTIVATE_DEACTIVATE_RES'

export const DELETE_COMPANY = 'DELETE_COMPANY'
export const CLEAR_DELETE_COMPANY_RES = 'CLEAR_DELETE_COMPANY_RES'

export const getUserListSuccess = (userList) => ({
  type: LIST_USER_SUCCESS,
  payload: userList,
})
export const getUserListFailure = (errorMessage) => ({
  type: LIST_USER_FAILURE,
  error: errorMessage,
})

export const getAllCompanySuccess = (companyList) => ({
  type: COMPANY_LIST_SUCCESS,
  payload: companyList,
})
export const getAllCompanyFailure = (errorMessage) => ({
  type: COMPANY_LIST_FAILURE,
  error: errorMessage,
})

export const getUserRolesSuccess = (roleList) => ({
  type: USER_ROLES_SUCCESS,
  payload: roleList,
})
export const getUserRolesFailure = (errorMessage) => ({
  type: USER_ROLES_FAILURE,
  error: errorMessage,
})

export const getRegionSuccess = (regionList) => ({
  type: GET_REGION_SUCCESS,
  payload: regionList,
})
export const getRegionFailure = (errorMessage) => ({
  type: GET_REGION_FAILURE,
  error: errorMessage,
})

export const createUserSuccess = (regionList) => ({
  type: CREATE_USER_SUCCESS,
  payload: regionList,
})
export const createUserFailure = (errorMessage) => ({
  type: CREATE_USER_FAILURE,
  error: errorMessage,
})

export const getEditUserSuccess = (editData) => ({
  type: EDIT_USER_SUCCESS,
  payload: editData,
})
export const getEditUserFailure = (errorMessage) => ({
  type: EDIT_USER_FAILURE,
  error: errorMessage,
})

export const updateUserSuccess = (updateData) => ({
  type: UPDATE_USER_SUCCESS,
  payload: updateData,
})
export const updateUserFailure = (errorMessage) => ({
  type: UPDATE_USER_FAILURE,
  error: errorMessage,
})

export const toggleUserSuccess = (data) => ({
  type: TOGGLE_USER_SUCCESS,
  payload: data,
})
export const toggleUserFailure = (errorMessage) => ({
  type: TOGGLE_USER_FAILURE,
  error: errorMessage,
})
export const toggleFaqSuccess = (data) => ({
  type: SEND_FAQ_QUERY_SUCCESS,
  payload: data,
})
export const toggleFaqFailure = (errorMessage) => ({
  type: SEND_FAQ_QUERY_ERROR,
  error: errorMessage,
})

//Action Creators
export const getUserList = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  // console.log('userDetails', userDetail)

  searchObj.current_user_id = userDetail.user_id
  searchObj.company_id = userDetail.company_id
  usersAPI
    .post('/user/All/bycompanyid/', searchObj)
    .then((res) => {
      dispatch(getUserListSuccess(res))
    })
    .catch((error) => {
      dispatch(getUserListFailure(error))
    })
}

// export const getCompanyList = () => (dispatch) => {
//   const userDetail = encryptStorage.getItem('session-user')
//   usersAPI
//     .get(`/user/getallcompany/${userDetail.company_id}`)
//     .then((res) => {
//       dispatch(getAllCompanySuccess(res.data))
//     })
//     .catch((error) => {
//       dispatch(getAllCompanyFailure(error))
//     })
// }

export const getCompanyList = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    company_id: `${userDetail.company_id}`,
    user_id: `${userDetail.user_id}`,
    project_id: 0,
  }
  usersAPI
    .post('/user/listteamcompany/', data)
    .then((res) => {
      dispatch(getAllCompanySuccess(res))
    })
    .catch((error) => {
      dispatch(getAllCompanyFailure(error))
    })
}

export const getUserRoles = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    company_id: `${userDetail.company_id}`,
    user_id: `${userDetail.user_id}`,
  }
  usersAPI
    .post('/user/rolebyhierarchy', data)
    .then((res) => {
      dispatch(getUserRolesSuccess(res))
    })
    .catch((error) => {
      dispatch(getUserRolesFailure(error))
    })
}

export const getRegionList = () => (dispatch) => {
  usersAPI
    .get('/user/region/All')
    .then((res) => {
      dispatch(getRegionSuccess(res.data))
    })
    .catch((error) => {
      dispatch(getRegionFailure(error))
    })
}

export const createUser = (data) => (dispatch) => {
  const dat = {
    ...data,
    userType: 'normalUser',
  }
  usersAPI
    .post('/user/add', dat)
    .then((res) => {
      dispatch(createUserSuccess(res.data))
    })
    .catch((error) => {
      dispatch(createUserFailure(error))
    })
}

export const editUser = (user_id) => (dispatch) => {
  usersAPI
    .get(`/user/${user_id}`)
    .then((res) => {
      console.log('editRes', res.data)
      dispatch(getEditUserSuccess(res.data))
    })
    .catch((error) => {
      dispatch(getEditUserFailure(error))
    })
}

export const updateUser = (data) => (dispatch) => {
  usersAPI
    .post(`/user/update`, data)
    .then((res) => {
      console.log('editRes', res.data)
      dispatch(updateUserSuccess(res.data))
    })
    .catch((error) => {
      dispatch(updateUserFailure(error))
    })
}

export const toggleUser = (userid, userStatus) => (dispatch) => {
  const activateDeactive = userStatus ? 'delete' : 'activate'
  usersAPI
    .get(`/user/${activateDeactive}/${userid}`)
    .then((res) => {
      console.log('toggleRes', res.data)
      dispatch(toggleUserSuccess(res.data))
    })
    .catch((error) => {
      dispatch(toggleUserFailure(error))
    })
}

export const sendFaqQuery = (query) => (dispatch) => {
  const userDetail = encryptStorage.getItem('session-user')
  const data = {
    email_id: `${userDetail.email_id}`,
    query: query,
  }
  usersAPI
    .post(`/user/queryfromuser`, data)
    .then((res) => {
      dispatch(toggleFaqSuccess(res.data))
    })
    .catch((error) => {
      dispatch(toggleFaqFailure(error))
    })
}

export const activateDeactivateCompany = (status, companyId) => (dispatch) => {
  usersAPI.put(`/user/license/company/${companyId}/activate/${!status}/`).then((response) => {
    dispatch({
      type: ACTIVATE_DEACTIVATE_COMPANY,
      payload: response.data,
    })
  })
}

export const clearActivateDeactivateRes = () => (dispatch) => {
  dispatch({ type: CLEAR_ACTIVATE_DEACTIVATE_RES })
}

export const deleteCompany = (companyId) => (dispatch) => {
  usersAPI.delete(`/user/license/company/${companyId}`).then((response) => {
    dispatch({
      type: DELETE_COMPANY,
      payload: response.data,
    })
  })
}

export const clearDeleteCompanyRes = () => (dispatch) => {
  dispatch({ type: CLEAR_DELETE_COMPANY_RES })
}
